import { type FC, useMemo, useState } from 'react'

import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

// Services
import { IconCalendarLinesWhite, IconNewStory } from 'assets/svg/sprite'
import { useModalContext } from 'context/modalContext'

import ScheduleBubble from './Components/ScheduleBubble'
import styles from './ScheduleContent.module.scss'
// Components
import DateModal from '../Date/DateModal'
import NewStream from '../NewStream/NewStream'

// Styling

const ScheduleContent: FC<{ date: Date }> = ({ date }) => {
    const [newDateVal, setNewDateVal] = useState<Date>(date)
    const { t } = useTranslation()
    const modalData = useModalContext()

    const linkQueryParams = useMemo(() => {
        const month = `0${newDateVal.getMonth() + 1}`
        const day = `0${newDateVal.getDate()}`
        const hours = `0${newDateVal.getHours()}`
        const minutes = `0${newDateVal.getMinutes()}`
        const seconds = `0${newDateVal.getSeconds()}`

        return `?date=${newDateVal.getFullYear()}-${month.slice(-2)}-${day.slice(
            -2
        )}T${hours.slice(-2)}:${minutes.slice(-2)}:${seconds.slice(-2)}`
    }, [newDateVal])

    const openNewStreamModal = () => {
        modalData.addModal('Schedule', <NewStream date={newDateVal} />, false)
    }
    
    const updateDate = (newDate: Date) => {
        setNewDateVal(newDate);
    };

    const toggleDateModal = () => {
        modalData.addModal(
            t('Set Date'),
            <DateModal confirmFn={(val: Date) => updateDate(val)}
            newDateVal={newDateVal}
            />

        );
    };
    const toggleDateModalTime = () => {
        modalData.addModal(
            t('Set Time'),
            <DateModal 
                confirmFn={(val: Date) => {
                    updateDate(val)
                }} 
                startTab="time"
                newDateVal={newDateVal}
            />
        );
    };
    

    return (
        <div>
            <div className={styles.bubblesContainer}>
                <div style={{flexGrow: 1}} onClick={toggleDateModal}>
                    <ScheduleBubble date={newDateVal} display='date' title={t('date')} />
                </div>
                <div style={{flexGrow: 1}} onClick={toggleDateModalTime}>
                    <ScheduleBubble date={newDateVal} display='time' title={t('time')} />
                </div>
            </div>
            <div className={styles.actionContainer}>
                <Link
                    className={styles.action}
                    to={`/new/post/create${linkQueryParams}`}
                    onClick={modalData.clearModal}
                >
                    <IconCalendarLinesWhite
                        width={'20'}
                        height={'20'}
                        color='#2894FF'
                    />
                    <span>{t('scheduleNewPost')}</span>
                </Link>
{/*                 <div className={styles.action} onClick={openNewStreamModal}>
                    <IconCalendarLinesWhite
                        width={'20'}
                        height={'20'}
                        color='#2894FF'
                    />
                    <span>{t('scheduleStream')}</span>
                </div> */}
                <Link
                    to={`/messages/new${linkQueryParams}`}
                    onClick={modalData.clearModal}
                    className={styles.action}
                >
                    <IconCalendarLinesWhite
                        width={'20'}
                        height={'20'}
                        color='#2894FF'
                    />
                    <span>{t('scheduleMassMessage')}</span>
                </Link>
                <Link
                    className={styles.action}
                    to={`/new/story${linkQueryParams}`}
                    onClick={modalData.clearModal}
                >
                    <IconNewStory width='20' height='20' />
                    <span>{t('scheduleStory')}</span>
                </Link>
                <div className={`${styles.action} ${styles.disabledAction}`}>
                <IconCalendarLinesWhite
                    width={'20'}
                    height={'20'}
                    color='#2894FF'
                />
                <span>{t('scheduleStream')}</span>
                </div>
            </div>
        </div>
    )
}

export default ScheduleContent
